// src/services/auth.js
export const isAuthenticated = () => {
  return Boolean(localStorage.getItem('token'));
};
